import React from 'react'
import LineItem from './LineItem'

export default function GroupsLineItemList({ items, showPricingType, onSelectedChange }) {

  return <>
    {items.map((item) =>
      <LineItem
        key={item.id}
        item={item}
        showPricingType={showPricingType}
        onIsSelectedChange={onSelectedChange}
      />
    )}
  </>
}
